import { Injectable } from "@angular/core";
@Injectable()
export class StringHelpers {
  
  camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

  isEmptyOrNull(str){
    if(str === '' || str === null || str === undefined){
      return true;
    }else{
      return false
    }
  }

  normalizeDateTime(dateTime: any): string {
    try {
      // Parse the date/time value
      const date = new Date(dateTime);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
      }

      // Return ISO string without timezone info (just the local time components)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    } catch (error) {
      console.error('Error normalizing date/time:', error);
      // Fallback to current time if parsing fails
      return new Date().toISOString().slice(0, 19);
    }
  }
}
